import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { resolveApiUrl } from "../../services/api";
import type { ProductItem } from "../../types";
import "./ProductCard.css";

interface ProductCardProps {
  product: ProductItem;
}

function ProductCard({ product }: ProductCardProps) {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.resolvedLanguage?.startsWith("ar") ?? false;

  const name = isArabic ? product.nameAr : product.nameEn;
  const desc = isArabic ? product.descAr : product.descEn;
  const cover = product.imageUrls?.[0];
  const imageCount = product.imageUrls?.length ?? 0;

  return (
    <Link to={`/products/${product.id}`} className="product-card reveal">
      {/* Image */}
      <div className="product-card__media">
        {cover ? (
          <img src={resolveApiUrl(cover)} alt={name} loading="lazy" />
        ) : (
          <div className="product-card__media-placeholder">
            <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" strokeWidth="1.5">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <polyline points="21 15 16 10 5 21" />
            </svg>
          </div>
        )}

        {imageCount > 1 && (
          <span className="product-card__badge">
            <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="18" height="18" rx="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <polyline points="21 15 16 10 5 21" />
            </svg>
            {imageCount}
          </span>
        )}
      </div>

      {/* Body */}
      <div className="product-card__body">
        <h3 className="product-card__name" title={name}>{name}</h3>
        {desc && <p className="product-card__desc">{desc}</p>}

        <span className="product-card__cta">
          {t("products.requestQuotation")}
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </span>
      </div>
    </Link>
  );
}

export default ProductCard;
